/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Heading } from "@nordcloud/gnui";

export function DefaultErrorFallback() {
  return (
    <div css={{ maxWidth: "100%", padding: "3rem" }}>
      <FlexContainer direction="column">
        <Heading level={1} mb={0}>
          Ooooops
        </Heading>
        <Heading level={4} mb={3}>
          Looks like something went wrong
          <br /> Our cloud ninjas are on their way to fix it.
        </Heading>
      </FlexContainer>
    </div>
  );
}
